module.exports = __webpack_public_path__ + "img/tc.bd3a6bd8.jpg";